import { useTranslation } from 'react-i18next'

export default function PrivacyPage() {
  const { t } = useTranslation()
  
  return (
    <div className="max-w-3xl mx-auto py-12 px-6">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">{t('legal.privacyTitle')}</h1>
      
      <div className="space-y-8 text-sm text-gray-700 leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.section1Title')}</h2>
          <p>{t('legal.section1Text')}</p>
        </section>
        
        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.section2Title')}</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>{t('legal.list2a')}</li>
            <li>{t('legal.list2b')}</li>
            <li>{t('legal.list2c')}</li>
          </ul>
        </section>
        
        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.section3Title')}</h2>
          <p>{t('legal.section3Text')}</p>
        </section>
        
        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.section4Title')}</h2>
          <p>{t('legal.section4Text')}</p>
        </section>
        
        <section>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">{t('legal.section5Title')}</h2>
          <p>{t('legal.section5Text')}</p>
        </section>
      </div>
    </div>
  )
}
